import { useCallback, useState } from "react";
import DataTable from "react-data-table-component";

import ButtonLoader from "../ButtonLoader";
import UserProfilePhoto from "../UserProfilePhoto";

const PartnerStaffAllocationForm = ({ project, staff, isAllocating, onAllocate, onCloseClicked }) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const [perPage, setPerPage] = useState(10);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleRowsPreselected = useCallback(row => {
    return project.assignedTo.map(user => user._id)?.includes(row._id);
  }, [project.assignedTo]);

  const staffColumns = [
    {
      cell: row => <UserProfilePhoto photoUrl={row.profilePicture} fullName={row.fullName} />,
      width: '75px'
    },
    {
      name: 'Name',
      selector: row => row.fullName
    },
    {
      name: 'Email',
      selector: row => row.email,
      grow: 2
    }
  ];

  const handleAllocate = async () => {
    if (selectedRows.length === 0) return;

    const labourerIds = selectedRows.map(row => row._id);

    const uniqueLabourerIds = [...new Set(labourerIds)];

    onAllocate(uniqueLabourerIds);
  }

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[750px] pb-1 overflow-visible">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>{project.name} Allocation</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <DataTable
        columns={staffColumns}
        data={staff}
        striped
        highlightOnHover
        pagination
        pointerOnHover
        paginationTotalRows={staff?.length}
        paginationRowsPerPageOptions={[10, 20, 50]}
        paginationPerPage={perPage}
        selectableRows
        selectableRowsHighlight
        onSelectedRowsChange={handleRowSelected}
        selectableRowSelected={handleRowsPreselected}
        noDataComponent={
          <div className="flex items-center justify-center py-8">
            No staff available for allocation
          </div>
        }
      />

      <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 px-4 py-4">
        <button
          onClick={handleAllocate}
          className="ase-button-primary flex items-center justify-center grow h-[36px]"
        >
          {isAllocating ? <ButtonLoader /> : 'Allocate'}
        </button>
      </div>
    </div>
  )
};

export default PartnerStaffAllocationForm;
